import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../img/ns_logo.png';
import logo_light from '../../img/logo_light.png';
import CartCounter from '../style-components/CartCounter';
import MenuItem from '../style-components/MenuItem';
import { Cross as Hamburger } from 'hamburger-react';
import { animateScroll as scroll, scroller } from 'react-scroll';
import { useTextService } from '../../services/useTextService';

// 1. Add these imports
import { GB } from 'country-flag-icons/react/3x2';
import { LV } from 'country-flag-icons/react/3x2';

// 2. Accept the new props here
function ClientMobile({ isHome, currentLang, handleLanguageSwitch }) {
    const [isOpen, setOpen] = useState(false);
    const [isSubmenuOpen, setSubmenuOpen] = useState(false);
    const [scrollToVeikals, setScrollToVeikals] = useState(false);

    const { getPlainValueByTag } = useTextService();

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
        setSubmenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        setSubmenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (scrollToVeikals && isHome) {
            scroller.scrollTo('veikals', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -100, 
            });
            setScrollToVeikals(false);
        }
    }, [scrollToVeikals, isHome]);

    const handleVeikalsClick = (e) => {
        setOpen(false);
        e.preventDefault();
        if (location.pathname !== '/') {
            setScrollToVeikals(true);
            navigate('/');
        } else {
            scroller.scrollTo('veikals', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -100, 
            });
        }
    };

    const handleLogoClick = () => {
        if (isHome) {
            scroll.scrollToTop({
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
            });
        } else {
            navigate('/');
        }
    };

    useEffect(() => {
        if (location.hash === '#veikals') {
            scroller.scrollTo('veikals', {
                duration: 800,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -100,
            });
        }
    }, [location]);

    return (
        <>
            <div className={`mobile-header ${isHome ? "light" : ""}`}>
                <div className="menu-trigger">
                    <Hamburger className="menu-trigger-icon" size={25} direction="right" toggled={isOpen} toggle={setOpen} />
                </div>
                <div className="logo" onClick={handleLogoClick}>
                    {isHome ? <img src={logo_light} alt="NoraSpora" /> : <img src={logo} alt="NoraSpora" />}
                </div>
                <div className="header-cart">
                    <CartCounter />
                </div>
            </div>
            {isOpen && (
                <div className={`mobile-menu ${isHome ? "light" : ""}`}>
                    <div className="menu-item-with-submenu">
                        <MenuItem text={getPlainValueByTag("menu-veikals")} onClick={handleVeikalsClick} />
                    </div>
                    <MenuItem text={getPlainValueByTag("menu-instrukcija")} link="/instrukcija" />
                    <MenuItem text={getPlainValueByTag("menu-jautajumi")} link="/jautajumi" />
                    <MenuItem text={getPlainValueByTag("menu-par-mums")} link="/about" />
                    <MenuItem text={getPlainValueByTag("menu-kontakti")} link="/contacts" />

                    {/* 3. Add this container for the flags */}
                    <div className="mobile-language-switcher">
                        <GB
                            title="English"
                            className={`language-flag ${currentLang === 'en' ? 'active' : ''}`}
                            onClick={() => handleLanguageSwitch('en')}
                            style={{ cursor: 'pointer' }}
                        />
                        <LV
                            title="Latviski"
                            className={`language-flag ${currentLang === 'lv' ? 'active' : ''}`}
                            onClick={() => handleLanguageSwitch('lv')}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}

export default ClientMobile;